<section class="content" xmlns="">
    <div class="container-fluid">
        <div class="row">
            <div class="row mt-3">
                <div class="row">
                    <div class="col-lg-5 col-md-6">
                        <div class="form-floating mb-3">
                            <select class="form-select" (change)="selectValue($event)">
                                <option value="">Select a Event Name</option>
                                <option *ngFor="let event of this.eventDetails" [value]="event.eventId">
                                    {{event.eventName}} -
                                    {{event.city}} -
                                    {{formattedDate(event?.eventDate)}}</option>
                                <!-- <option value="192">CIFA Surabhi - Indian Classical Dance Performance - Aug-3</option>
                <option value="180">CIFA Surabhi - Indian Classical Dance Performance - Sep-14</option> -->
                            </select>
                            <label for="formId1">Event Name</label>
                        </div>
                    </div>

                    <div class="col-lg-5 col-md-6">
                        <div class="form-floating mb-3">
                            <input type="text" [(ngModel)]="searchText" class="form-control"
                                placeholder="Search by Name, Email or Phone Number">
                            <label>Search</label>
                        </div>
                    </div>

                    <div class="col-12 col-md-2 text-md-end mt-2">
                        <button class="btn btn-success w-100 w-md-auto" (click)="generateExcelSheet()">
                            <i class="fa-solid fa-file-excel"></i> Generate Excel
                        </button>
                    </div>

                </div>

                <mat-card class="order-card">
                    <div class="container-fluid">
                        <div class="row">
                            <mat-card-content>
                                <div class="container-fluid mt-1">
                                    <div class="table-responsive table-style table-bordered">
                                        <table class="table table-gray table-head-fixed">
                                            <thead class="h6">
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Name</th>
                                                    <th>Phone Number</th>
                                                    <th>Email ID</th>
                                                    <th>Age</th>
                                                    <th>Gender</th>
                                                    <th>City</th>
                                                    <th>State</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="volunteerDetailList.length > 0; else noDataFound">
                                                <tr class="text-center"
                                                    *ngFor="let work of volunteerDetailList | filter : searchText; let i = index;">
                                                    <td>{{ i + 1 }}</td>
                                                    <td>{{work?.name || "-"}}</td>
                                                    <td>{{work?.phone || "-"}}</td>
                                                    <td>{{work?.email || "-"}}</td>
                                                    <td>{{work?.age || "-"}}</td>
                                                    <td>{{work?.gender || "-"}}</td>
                                                    <td>{{work?.city || "-"}}</td>
                                                    <td>{{work?.state || "-"}}</td>

                                                </tr>
                                            </tbody>
                                            <ng-template #noDataFound>
                                                <tr>
                                                    <td colspan="11" class="text-center fw-bold">Data Not Found</td>
                                                </tr>
                                            </ng-template>
                                        </table>
                                    </div>
                                </div>
                            </mat-card-content>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
</section>